// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCnpk8iuTAAbIgEv8OJsOGOF-a2lWlNExg",
    authDomain: "accessit-6bfe9.firebaseapp.com",
    projectId: "accessit-6bfe9",
    storageBucket: "accessit-6bfe9.appspot.com",
    messagingSenderId: "270363007732",
    appId: "1:270363007732:web:b9adc2a3183fba76775ca1"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
